const FEES = [
  {
    priceFrom: 0,
    priceTo: 2499,
    brokerFee: 249,
  },
  {
    priceFrom: 2500,
    priceTo: 4999,
    brokerFee: 269,
  },
  {
    priceFrom: 5000,
    priceTo: 7499,
    brokerFee: 289,
  },
  {
    priceFrom: 7500,
    priceTo: 9999,
    brokerFee: 319,
  },
  {
    priceFrom: 10000,
    priceTo: 14999,
    brokerFee: 349,
  },
  {
    priceFrom: 15000,
    priceTo: 19999,
    brokerFee: 369,
  },
  {
    priceFrom: 20000,
    priceTo: 29999,
    brokerFee: 419,
  },
  {
    priceFrom: 30000,
    priceTo: 39999,
    brokerFee: 469,
  },
  {
    priceFrom: 40000,
    priceTo: 49999,
    brokerFee: 519,
  },
  {
    priceFrom: 50000,
    priceTo: 59999,
    brokerFee: 609,
  },
  {
    priceFrom: 60000,
    priceTo: 69999,
    brokerFee: 699,
  },
  {
    priceFrom: 70000,
    priceTo: 79999,
    brokerFee: 789,
  },
  {
    priceFrom: 80000,
    priceTo: 89999,
    brokerFee: 879,
  },
  {
    priceFrom: 90000,
    priceTo: 99999,
    brokerFee: 919,
  },
  {
    priceFrom: 100000,
    priceTo: null,
    brokerFee: 1019,
  },
];

module.exports = FEES;
